import { Button, Grid, withStyles, FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';
import CloudDownload from '@material-ui/icons/CloudDownload';

import PropTypes from 'prop-types';
import React, { Component } from 'react';

import combineStyles from '../../../helpers/combineStyles';

import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';

import InputFile from '../../shared/Inputs/InputFile';

class BulkLoad extends Component {
  render() {
    const { classes, handleChangeFile, templatePath, massivePrintInBill, onChangeCheckBox, isManualQuota = false } = this.props;

    return (
      <Grid container spacing={16} justify="space-between" alignItems="center">
        <Grid item sm={isManualQuota ? 12 : 8} xs={12}>
          <InputFile
            onChange={handleChangeFile}
            accept=".csv"
            //error={!!this.state.fileError}
            //helperText={this.state.fileError}
          />
        </Grid>
        {isManualQuota && (
          <Grid item sm={7} xs={12}>
          <FormControlLabel
              control={
                <Checkbox
                  name="massivePrintInBill"
                  checked={massivePrintInBill}
                  onChange={onChangeCheckBox}
                />
              }
              label="Imprime factura"
            />
            <FormHelperText style={{ marginTop: 0 }}>Esta configuración se aplicará a todos los archivos cargados</FormHelperText>
          </Grid>
        )}
        <Grid item sm={isManualQuota ? 5 : 4} xs={12} className={classes.centerText}>
          <a
            href={templatePath}
            className={classes.noDecorationAnchor}
            download
          >
            <Button color="secondary">
              {'Plantilla Base'} <CloudDownload style={{ marginLeft: '8px' }} />
            </Button>
          </a>
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  noDecorationAnchor: {
    textDecoration: 'none'
  },
  centerText: {
    justifyContent: 'center',
    display: 'flex'
  }
});

BulkLoad.propTypes = {
  handleChangeFile: PropTypes.func,
  templatePath: PropTypes.string
};

export default withStyles(
  combineStyles(styles, TypographyStyles, ButtonStyles),
  {
    withTheme: true
  }
)(BulkLoad);
